import { render, staticRenderFns } from "./ArtworkContent.vue?vue&type=template&id=0e6d17b1&scoped=true&"
import script from "./ArtworkContent.vue?vue&type=script&lang=js&"
export * from "./ArtworkContent.vue?vue&type=script&lang=js&"
import style0 from "./ArtworkContent.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ArtworkContent.vue?vue&type=style&index=1&id=0e6d17b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6d17b1",
  null
  
)

export default component.exports